
import React from 'react';

const BusinessPartnerSection = () => {
  return (
    <section>
      <h2 className="text-2xl font-semibold mb-4">E. Contractual Relationship with us as business partner</h2>
      <div className="space-y-4">
        <p className="text-gray-600">
          As part of a contractual relationship with us in the context of cooperation as a service provider, supplier, and other business partners, we process, among other things, the following personal data:
        </p>
        <ul className="list-disc pl-6 space-y-2 text-gray-600">
          <li>your name and contact information (including name, address, telephone number, or email address);</li>
          <li>information about the company you work for, your position, or your title;</li>
          <li>identification and background information that you provide to us or that we collect from you in the context of establishing the contractual relationship;</li>
          <li>invoice and payment information;</li>
          <li>Information that you provide to us in the context of and for the purposes of providing services to us or that you create in the course of providing services to us, including order-related communication;</li>
          <li>personal data of third parties that are required for establishing the contractual relationship or providing services by you;</li>
          <li>any other information related to you that you provide to us in connection with the contractual relationship.</li>
        </ul>
        
        <p className="text-gray-600">
          The information we collect and process about you results from your interaction with us and your provision of services to us. We may also obtain information about you from other sources such as authorities (e.g., as part of file inspection and/or information requests) or publicly accessible sources (public registers, internet research) to update your information. We process this information to communicate with you, to perform anti-money laundering, conflict, and reputation checks before establishing the contractual relationship, to be able to obtain the services we require, to pay invoices, and to maintain our business relationship with you, including asserting, enforcing, and defending legal claims.
        </p>
        
        <p className="text-gray-600">
          To the extent necessary for the provision of your services, we may disclose personal data to the following recipients:
        </p>
        <ul className="list-disc pl-6 space-y-2 text-gray-600">
          <li>authorities.</li>
        </ul>
        
        <p className="text-gray-600">
          The legal basis for processing your personal data for the aforementioned purposes lies in pre-contractual measures and the performance of a contract in accordance with Art. 6 para. 1 let. b EU-GDPR, as well as, if applicable, in our legitimate interest in the targeted and efficient use of your services in accordance with Art. 6 para. 1 let. f EU-GDPR.
        </p>
      </div>
    </section>
  );
};

export default BusinessPartnerSection;
